import { Dropdown, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// import NineDotMenu from './NineDotMenu';
import ProfileDropdownMenu from './ProfileDropdownMenu';
import AdminProfileDropdownMenu from 'admin-shiplab/AdminProfileDropdownMenu';
import { useIsAdminApp } from 'admin-shiplab/AdminAppProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ThemeToggler from 'components/common/ThemeToggler';
// import { useMemo } from 'react';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
// import ViewPlansButton from './ViewPlansButton';
// import useCustomer from 'hooks/useCustomer';
// import { getTrialDaysRemaining } from 'utils/trial';

const NavItemsSlim = () => {
  const isAdminApp = useIsAdminApp();
  // const { profile } = useCustomer();
  // const trialDaysRemaining = useMemo(
  //   () => getTrialDaysRemaining(profile?.created_at),
  //   [profile?.created_at]
  // );
  return (
    <div className="navbar-nav navbar-nav-icons flex-row">
      {/* View Plans + trial countdown - temporarily disabled
      <ViewPlansButton
        renderTrigger={openPricing => (
          <Nav.Item className="d-flex align-items-center ms-2">
            <Nav.Link
              as="button"
              type="button"
              className="text-body-secondary fw-semibold p-0 border-0 bg-transparent shadow-none"
              style={{ fontSize: '0.9375rem', outline: 'none', boxShadow: 'none' }}
              onClick={openPricing}
            >
              Trial · {trialDaysRemaining} days
            </Nav.Link>
          </Nav.Item>
        )}
      />
      <ViewPlansButton />
      */}
      <Nav.Item className="d-flex align-items-center">
        <span
          aria-hidden="true"
          className="border-start mx-2"
          style={{ height: 20 }}
        />
      </Nav.Item>
      <Nav.Item>
        <ThemeToggler slim />
      </Nav.Item>

      {/* <Nav.Item>
        <Dropdown autoClose="outside">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link py-0"
            variant=""
          >
            <svg
              width="10"
              height="10"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="2" cy="2" r="2" fill="currentColor"></circle>
              <circle cx="2" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="2" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="2" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="2" r="2" fill="currentColor"></circle>
            </svg>
          </Dropdown.Toggle>
          <NineDotMenu />
        </Dropdown>
      </Nav.Item> */}
      <Nav.Item>
        <Dropdown autoClose="outside">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link pe-0 py-0"
            variant=""
          >
            Olivia <FontAwesomeIcon icon={faChevronDown} className="fs-10" />
          </Dropdown.Toggle>
          {isAdminApp ? <AdminProfileDropdownMenu /> : <ProfileDropdownMenu />}
        </Dropdown>
      </Nav.Item>
    </div>
  );
};

export default NavItemsSlim;
